// UI 插画与背景图：放在 CDN（OSS static/ → static.cs2coach.cn），文件名带内容哈希，可永久缓存。
// 更新图片：backend `go run ./cmd/osstool static <目录> ui/illustrations`，把输出的路径替换到下面。
const STATIC_BASE = (import.meta.env.VITE_STATIC_BASE_URL || "https://static.cs2coach.cn").replace(/\/+$/, "");

const PATHS = {
  "auth-hero": "ui/illustrations/auth-hero.199101478d.webp",
  "demo-failed": "ui/illustrations/demo-failed.eb18642880.png",
  "demo-processing": "ui/illustrations/demo-processing.d297393d27.png",
  "empty-demos": "ui/illustrations/empty-demos.a144cc6e6a.png",
  "empty-inventory": "ui/illustrations/empty-inventory.04c5f0e64b.png",
  "empty-matches": "ui/illustrations/empty-matches.c30d45229d.png",
  "empty-search": "ui/illustrations/empty-search.94b6291237.png",
  "empty-tactics": "ui/illustrations/empty-tactics.82be982fec.png",
  "empty-team": "ui/illustrations/empty-team.6d8274dd06.png",
  "error-bg": "ui/illustrations/error-bg.2682f89277.webp",
  "kills-empty": "ui/illustrations/kills-empty.925e4b2076.png",
  "link-steam": "ui/illustrations/link-steam.3482f7601d.png",
  "map-unsupported": "ui/illustrations/map-unsupported.3ca0e59c85.png",
  "not-found": "ui/illustrations/not-found.e270a62b65.webp",
  "skins-backdrop": "ui/illustrations/skins-backdrop.c49d3a209c.webp",
  "skins-locked": "ui/illustrations/skins-locked.e1a214fa9c.png",
} as const;

export type Illustration = keyof typeof PATHS;

export const illustrationUrl = (name: Illustration) => `${STATIC_BASE}/${PATHS[name]}`;
